import loadable from '@loadable/component';

export const SeasonalEventMerchants = loadable(
  () => import(/* webpackChunkName: 'seasonal-event-merchants' */ './SeasonalEventMerchants'),
);
